import { DataModel } from "@toolpad/core/Crud";
import {
  IBatterySubscriptionSummaryDto,
  SubscriptionStatus,
} from "../generated/api-client";
import { enumToValueOptions, nameof } from "../utils/object.utils";
import MagicCrud, { MagicCrudFields } from "../components/MagicCrud";

type BatterySubscriptionDataModel = IBatterySubscriptionSummaryDto & DataModel;

export default function BatterySubscriptionsPage() {
  const columns: MagicCrudFields<IBatterySubscriptionSummaryDto>[] = [
    {
      field: nameof<IBatterySubscriptionSummaryDto>("shopSubscriptionId"),
      headerName: "shopSubscriptionId",
      type: "string",
      width: 220,
      isRequired: true,
      notInEditMode: true,
    },
    {
      field: nameof<IBatterySubscriptionSummaryDto>("groupId"),
      headerName: "groupId",
      type: "string",
      extraType: "guid",
      width: 220,
      isRequired: true,
      notInEditMode: true,
    },
    {
      field: nameof<IBatterySubscriptionSummaryDto>("groupCreateUserId"),
      headerName: "groupCreateUserId",
      type: "string",
      width: 180,
      notInEditMode: true,
      notInCreateMode: true,
    },
    {
      field: nameof<IBatterySubscriptionSummaryDto>("groupCreatedUserEmail"),
      headerName: "groupCreatedUserEmail",
      type: "string",
      width: 200,
      notInEditMode: true,
      notInCreateMode: true,
    },
    {
      field: nameof<IBatterySubscriptionSummaryDto>("status"),
      headerName: "subscriptionStatus",
      type: "singleSelect",
      valueOptions: enumToValueOptions(SubscriptionStatus),
      width: 140,
      isRequired: true,
    },
    {
      field: nameof<IBatterySubscriptionSummaryDto>("expirationDate"),
      headerName: "subscriptionExpirationDate",
      type: "date",
      width: 220,
      isRequired: true,
    },
  ];

  return (
    <MagicCrud<BatterySubscriptionDataModel>
      name="batterySubscription"
      apiUrl="subscriptions/batteries"
      columns={columns}
      appUrl="/battery-subscriptions"
      getRowId={(row) => row.shopSubscriptionId ?? ""}
    />
  );
}
